module.exports = __webpack_public_path__ + "lk.43cbeee0f9a573ac5823.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/lk.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/lk.svg
// module chunks = styles